// Component names
export var NAME_ALERT = 'BAlert';
export var NAME_ASPECT = 'BAspect';
export var NAME_AVATAR = 'BAvatar';
export var NAME_AVATAR_GROUP = 'BAvatarGroup';
export var NAME_BADGE = 'BBadge';
export var NAME_BREADCRUMB = 'BBreadcrumb';
export var NAME_BREADCRUMB_ITEM = 'BBreadcrumbItem';
export var NAME_BREADCRUMB_LINK = 'BBreadcrumbLink';
export var NAME_BUTTON = 'BButton';
export var NAME_BUTTON_CLOSE = 'BButtonClose';
export var NAME_BUTTON_GROUP = 'BButtonGroup';
export var NAME_BUTTON_TOOLBAR = 'BButtonToolbar';
export var NAME_CALENDAR = 'BCalendar';
export var NAME_CARD = 'BCard';
export var NAME_CARD_BODY = 'BCardBody';
export var NAME_CARD_FOOTER = 'BCardFooter';
export var NAME_CARD_GROUP = 'BCardGroup';
export var NAME_CARD_HEADER = 'BCardHeader';
export var NAME_CARD_IMG = 'BCardImg';
export var NAME_CARD_IMG_LAZY = 'BCardImgLazy';
export var NAME_CARD_SUB_TITLE = 'BCardSubTitle';
export var NAME_CARD_TEXT = 'BCardText';
export var NAME_CARD_TITLE = 'BCardTitle';
export var NAME_CAROUSEL = 'BCarousel';
export var NAME_CAROUSEL_SLIDE = 'BCarouselSlide';
export var NAME_COL = 'BCol';
export var NAME_COLLAPSE = 'BCollapse';
export var NAME_CONTAINER = 'BContainer';
export var NAME_DROPDOWN = 'BDropdown';
export var NAME_DROPDOWN_DIVIDER = 'BDropdownDivider';
export var NAME_DROPDOWN_FORM = 'BDropdownForm';
export var NAME_DROPDOWN_GROUP = 'BDropdownGroup';
export var NAME_DROPDOWN_HEADER = 'BDropdownHeader';
export var NAME_DROPDOWN_ITEM = 'BDropdownItem';
export var NAME_DROPDOWN_ITEM_BUTTON = 'BDropdownItemButton';
export var NAME_DROPDOWN_TEXT = 'BDropdownText';
export var NAME_EMBED = 'BEmbed';
export var NAME_FORM = 'BForm';
export var NAME_FORM_CHECKBOX = 'BFormCheckbox';
export var NAME_FORM_CHECKBOX_GROUP = 'BFormCheckboxGroup';
export var NAME_FORM_DATALIST = 'BFormDatalist';
export var NAME_FORM_DATEPICKER = 'BFormDatepicker';
export var NAME_FORM_FILE = 'BFormFile';
export var NAME_FORM_GROUP = 'BFormGroup';
export var NAME_FORM_INPUT = 'BFormInput';
export var NAME_FORM_INVALID_FEEDBACK = 'BFormInvalidFeedback';
export var NAME_FORM_RADIO = 'BFormRadio';
export var NAME_FORM_RADIO_GROUP = 'BFormRadioGroup';
export var NAME_FORM_RATING = 'BFormRating';
export var NAME_FORM_ROW = 'BFormRow';
export var NAME_FORM_SELECT = 'BFormSelect';
export var NAME_FORM_SELECT_OPTION = 'BFormSelectOption';
export var NAME_FORM_SELECT_OPTION_GROUP = 'BFormSelectOptionGroup';
export var NAME_FORM_SPINBUTTON = 'BFormSpinbutton';
export var NAME_FORM_TAG = 'BFormTag';
export var NAME_FORM_TAGS = 'BFormTags';
export var NAME_FORM_TEXT = 'BFormText';
export var NAME_FORM_TEXTAREA = 'BFormTextarea';
export var NAME_FORM_TIMEPICKER = 'BFormTimepicker';
export var NAME_FORM_VALID_FEEDBACK = 'BFormValidFeedback';
export var NAME_ICON = 'BIcon';
export var NAME_ICONSTACK = 'BIconstack';
export var NAME_ICON_BASE = 'BIconBase';
export var NAME_IMG = 'BImg';
export var NAME_IMG_LAZY = 'BImgLazy';
export var NAME_INPUT_GROUP = 'BInputGroup';
export var NAME_INPUT_GROUP_ADDON = 'BInputGroupAddon';
export var NAME_INPUT_GROUP_APPEND = 'BInputGroupAppend';
export var NAME_INPUT_GROUP_PREPEND = 'BInputGroupPrepend';
export var NAME_INPUT_GROUP_TEXT = 'BInputGroupText';
export var NAME_JUMBOTRON = 'BJumbotron';
export var NAME_LINK = 'BLink';
export var NAME_LIST_GROUP = 'BListGroup';
export var NAME_LIST_GROUP_ITEM = 'BListGroupItem';
export var NAME_MEDIA = 'BMedia';
export var NAME_MEDIA_ASIDE = 'BMediaAside';
export var NAME_MEDIA_BODY = 'BMediaBody';
export var NAME_MODAL = 'BModal';
export var NAME_MSG_BOX = 'BMsgBox';
export var NAME_NAV = 'BNav';
export var NAME_NAVBAR = 'BNavbar';
export var NAME_NAVBAR_BRAND = 'BNavbarBrand';
export var NAME_NAVBAR_NAV = 'BNavbarNav';
export var NAME_NAVBAR_TOGGLE = 'BNavbarToggle';
export var NAME_NAV_FORM = 'BNavForm';
export var NAME_NAV_ITEM = 'BNavItem';
export var NAME_NAV_ITEM_DROPDOWN = 'BNavItemDropdown';
export var NAME_NAV_TEXT = 'BNavText';
export var NAME_OVERLAY = 'BOverlay';
export var NAME_PAGINATION = 'BPagination';
export var NAME_PAGINATION_NAV = 'BPaginationNav';
export var NAME_POPOVER = 'BPopover';
export var NAME_PROGRESS = 'BProgress';
export var NAME_PROGRESS_BAR = 'BProgressBar';
export var NAME_ROW = 'BRow';
export var NAME_SIDEBAR = 'BSidebar';
export var NAME_SKELETON = 'BSkeleton';
export var NAME_SKELETON_ICON = 'BSkeletonIcon';
export var NAME_SKELETON_IMG = 'BSkeletonImg';
export var NAME_SKELETON_TABLE = 'BSkeletonTable';
export var NAME_SKELETON_WRAPPER = 'BSkeletonWrapper';
export var NAME_SPINNER = 'BSpinner';
export var NAME_TAB = 'BTab';
export var NAME_TABLE = 'BTable';
export var NAME_TABLE_CELL = 'BTableCell';
export var NAME_TABLE_LITE = 'BTableLite';
export var NAME_TABLE_SIMPLE = 'BTableSimple';
export var NAME_TABS = 'BTabs';
export var NAME_TBODY = 'BTbody';
export var NAME_TFOOT = 'BTfoot';
export var NAME_TH = 'BTh';
export var NAME_THEAD = 'BThead';
export var NAME_TIME = 'BTime';
export var NAME_TOAST = 'BToast';
export var NAME_TOASTER = 'BToaster';
export var NAME_TOOLTIP = 'BTooltip';
export var NAME_TR = 'BTr'; // Helper component names

export var NAME_COLLAPSE_HELPER = 'BVCollapse';
export var NAME_FORM_BUTTON_LABEL_CONTROL = 'BVFormBtnLabelControl';
export var NAME_FORM_RATING_STAR = 'BVFormRatingStar';
export var NAME_POPOVER_HELPER = 'BVPopover';
export var NAME_POPOVER_TEMPLATE = 'BVPopoverTemplate';
export var NAME_POPPER = 'BVPopper';
export var NAME_TAB_BUTTON_HELPER = 'BVTabButton';
export var NAME_TOAST_POP = 'BVToastPop';
export var NAME_TOOLTIP_HELPER = 'BVTooltip';
export var NAME_TOOLTIP_TEMPLATE = 'BVTooltipTemplate';
export var NAME_TRANSITION = 'BVTransition';
export var NAME_TRANSPORTER = 'BVTransporter';
export var NAME_TRANSPORTER_TARGET = 'BVTransporterTarget';


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/constants/components.js
// module id = 8
// module chunks = 1